// jQuery's UMD build takes its CommonJS branch inside a bundler, which deliberately
// leaves `window` alone. The Pyxis pack needs the real globals: jquery-ujs binds itself
// off `window.jQuery` the moment it is imported, util.js extends `jQuery.fn`, and
// several Pyxis components call `$` directly. Import this before any of them.
//
// ES module imports are evaluated in source order, so importing this module first is
// what guarantees the globals exist by the time those dependents run.
import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

export default jQuery;
